export default "__VITE_ASSET__5a8e9afb__"